export const SLATE = "#12262B";
export const INK = "#1A1A1A";
export const RULE = "#333";
export const LINE = "#C9CED6";
export const TEAL = "#15A08C";
export const TEAL_HOVER = "#0F8474";
export const MUTED = "#5F6B7A";